import * as React from 'react';
import * as moment from 'moment';
import ReactHtmlParser from 'react-html-parser';
import { capitalize } from 'lodash';
import { getContactInformation } from 'src/share/utils/formatContactInfo';
import { stringDateToLongFormat, momentAgeNow, getCurrentYear } from 'src/share/utils/utils';

const PDBanner = ({ id, child, isCurrent }): React.ReactElement => {
  const formattedDate = React.useMemo(() => stringDateToLongFormat(child.missingDate), [child]);
  const childAge = React.useMemo(() => {
    return child.age || child.birthday && momentAgeNow(moment(child.birthday, 'DD/MM/YYYY')) || child.yearOfBirth && getCurrentYear() - child.yearOfBirth || 'Unknown';
  }, [child]);
  return (
    <div 
      className="partners-dashboard__banner" 
      aria-hidden={!isCurrent}
      aria-labelledby={id}
    >
      <div className="banner-header">
        Missing
      </div>
      <div className="banner-body">
        <div className="child-photo">
          <img src={child.photo} alt="Child Photo"/>
        </div>
        <div className="child-information">
          <div className="information-line">
            <h5>Name</h5>
            <p>{child.fullName}</p>
          </div>
          <div className="information-line">
            <h5>Age</h5>
            <p>{childAge} {childAge !== 'Unknown' && 'years'}.</p>
          </div>
          <div className="information-line">
            <h5>Sex</h5>
            <p>{capitalize(child.sex)}</p>
          </div>
          <div className="information-line">
            <h5>Country</h5>
            <p>{child.country}</p>
          </div>
          <div className="information-line">
            <h5>Location</h5>
            <p>{child.location}</p>
          </div>
          <div className="information-line">
            <h5>Missing Date</h5>
            <p>{formattedDate}</p>
          </div>
        </div>
      </div>
      <div className="banner-footer">
        <div className="contact-information">
          <h5>Circumstances</h5>
          {ReactHtmlParser(getContactInformation(child.circumstances))}
        </div>
        <br />
        <div className="contact-information">
          <h5>Contact Information</h5>
          {ReactHtmlParser(getContactInformation(child.contactInformation))}
        </div>
      </div>
    </div>
  )
}

export default React.memo(PDBanner)



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Partners/components/PDBanner.tsx